<template>
  <div class="serve_introduce">
    <div class="photo_topic" v-if="product.themeVos && product.themeVos.length">
      <div class="photo_topic_title">
        可选主题 ({{ product.themeVos.length }})
      </div>
      <div class="photo_topic_content">
        <!-- <div class="photo_topic_list" v-if="product.themeVos.length > 1"> -->
        <div class="photo_topic_list">
          <div
            class="photo_topic_item"
            v-for="(item, index) in product.themeVos"
            :key="index"
          >
            <div class="photo_topic_photo">
              <img
                v-lazy="$$viewImage(item.themePics[0])"
                @click="showImage(item.themePics, 0)"
              />
            </div>
            <div class="photo_topic_info">
              <div class="photo_topic_name">{{ item.themeName }}</div>
            </div>
          </div>
        </div>
        <!-- <div class="photo_topic_list" v-else>
          <div
            class="photo_topic_item"
            v-for="(item, index) in product.themeVos[0].themePics"
            :key="index"
          >
            <div class="photo_topic_photo">
              <img v-lazy="$$viewImage(item)" @click="showImage([item], 0)" />
            </div>
            <div class="photo_topic_info">
              <div class="photo_topic_name">
                {{ product.themeVos[0].themeName }}
              </div>
              <div class="photo_topic_label">
                <span
                  v-for="(items, indexs) in product.themeVos[0]"
                  :key="indexs"
                >
                  #{{ items }}
                </span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="photo_basic_warp" v-if="basicPhoto.length > 0">
      <div class="serve_introduce_title pf-medium">套餐介绍</div>
      <div class="basic_photo">
        <div
          v-for="(item, index) in basicPhoto"
          :key="index"
          ref="photo"
          class="basic_item"
        >
          <div class="basic_child">
            <img :src="item.icon" />
            <div class="info">
              <p>{{ item.name }}</p>
              <div>{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="photo_warpper"
      :class="{ isAll: !!isAllPhotoAttrs, noMore: noImgText }"
    >
      <div
        class="photo_item_warp"
        v-for="(item, index) in basicMore.slice(0, photoAttrsLength)"
        :key="index"
      >
        <div class="serve_introduce_title pf-medium top48">
          {{ item.title }}
        </div>
        <div class="info" v-for="(item1, index1) in item.items" :key="index1">
          <p>{{ item1.name }}</p>
          <div>{{ item1.value }}</div>
        </div>
      </div>
      <button
        v-if="basicMore.length > 2"
        class="more-look"
        @click="openPhotoTextDetail"
      ></button>
    </div>
    <!-- 
    <div class="bright-content" v-if="product.spuDesc">
      <div class="bright">
        <div class="serve_introduce_title pf-medium bright_title">亮点介绍</div>
        <div class="content_detail">{{ product.spuDesc }}</div>
      </div>
    </div> -->
    <div
      class="image_text"
      v-if="(cmmdtyPicDetail && cmmdtyPicDetail.length > 0) || product.content"
      :class="{ isAll: !!isAllImgText, noMore: noImgText }"
    >
      <div class="serve_introduce_title pf-medium image_text_title">
        图文详情
      </div>
      <div class="pDetail" v-if="cmmdtyPicDetail && cmmdtyPicDetail.length > 0">
        <div
          class="img-detail"
          v-for="(item, index) in cmmdtyPicDetail"
          :key="index"
        >
          <img v-lazy="item" alt="" />
        </div>
      </div>
      <div class="pDetail" v-else v-xhtml="product.content"></div>
      <button class="more-look" @click="openImgTextDetail"></button>
    </div>
    <van-image-preview v-model="show" :images="images" @change="onChange">
      <template #index>
        <span>{{ imageIndex + 1 }}</span>
        <span class="gray">/{{ images.length }}</span>
      </template>
    </van-image-preview>
    <!-- 解决图片预览滚动条的问题 -->
    <div v-van-image-preview-scroll-fix="show"></div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import utils from '@/plugins/utils'
import { IMAGES_STORAGE_KEY } from '@/router/viewImageFullScreen/config'

export default {
  props: {
    product: {
      type: Object
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  computed: {
    cmmdtyPicDetail() {
      // 图文详情
      const list =
        this.product && this.product.cmmdtyPicDetail
          ? this.product.cmmdtyPicDetail.split(',')
          : []
      return list
    },
    basicPhoto() {
      if (this.product && this.product.showTextAttrs) {
        return this.product.showTextAttrs.basic
      }
      return []
    },
    basicMore() {
      if (this.product && this.product.showTextAttrs) {
        return this.product.showTextAttrs.more
      }
      return []
    }
  },
  data() {
    return {
      isAllImgText: false,
      isAllPhotoAttrs: false,
      showPdIndex: 1,
      noImgText: false,
      photoAttrsLength: 0,
      show: false,
      images: [],
      imageIndex: 0
    }
  },
  watch: {
    isAllPhotoAttrs(val) {
      if (val) {
        this.photoAttrsLength = this.basicMore.length
      } else {
        this.photoAttrsLength = 2
      }
    }
  },
  mounted() {
    //中间居中对齐 哪个宽度大 间距以哪个为准   右边靠右对齐 哪个宽度大 间距以哪个为准
    if (this.$refs && this.$refs.photo && this.$refs.photo.length > 1) {
      const { width } = this.$refs.photo[0].getBoundingClientRect()
      const childWidth1 = Math.max(this.getChildWidth(1), this.getChildWidth(4))
      this.setCenter(1, width, childWidth1)
      this.setCenter(4, width, childWidth1)

      const childWidth2 = Math.max(this.getChildWidth(2), this.getChildWidth(5))
      this.setMarginLeft(2, width, childWidth2)
      this.setMarginLeft(5, width, childWidth2)
    }
    this.photoAttrsLength = this.basicMore.length > 2 ? 2 : basicMore.length
  },
  methods: {
    openImgTextDetail() {
      this.isAllImgText = !this.isAllImgText
    },
    openPhotoTextDetail() {
      this.isAllPhotoAttrs = !this.isAllPhotoAttrs
    },
    getChildWidth(index) {
      if (this.$refs && this.$refs.photo && this.$refs.photo.length > index) {
        var child = this.$refs.photo[index]
        if (child) return child.children[0].getBoundingClientRect().width
      } else {
        return 0
      }
    },
    setCenter(index, parentWidth, childWidth) {
      if (this.$refs && this.$refs.photo && this.$refs.photo.length > index) {
        var child = this.$refs.photo[index]
        const centerMargin = (parentWidth - childWidth) / 2
        if (centerMargin > 0 && child) {
          child.children[0].style.marginLeft = centerMargin + 'px'
        }
      }
    },
    setMarginLeft(index, parentWidth, childWidth) {
      if (this.$refs && this.$refs.photo && this.$refs.photo.length > index) {
        var child = this.$refs.photo[index]
        const marginLeft = parentWidth - childWidth
        if (marginLeft > 0 && child) {
          child.children[0].style.marginLeft = marginLeft + 'px'
        }
      }
    },
    showImage(images, index) {
      if (utils.isHzwApp()) {
        // 目前来看仅孩子王APP支持全屏网页，人客和商客都不行
        const imageList = images.map(item => {
          return {
            imgUrl: item
          }
        })
        localStorage.setItem(IMAGES_STORAGE_KEY, JSON.stringify(imageList))
        return window.open('/v/viewImageFullScreen?&naviType=4')
      }
      this.images = images
      this.show = true
    },
    onChange(index) {
      this.imageIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.serve_introduce {
  .photo_topic {
    background-color: #fff;
    .photo_topic_title {
      height: rem(34px);
      padding: rem(32px) rem(30px);
      margin-bottom: rem(32px);
      font-size: rem(28px);
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: left;
      color: #121212;
      line-height: rem(34px);
    }
    .photo_topic_content {
      overflow: hidden;
      height: rem(300px);
    }
    .photo_topic_list {
      overflow-x: scroll;
      -webkit-overflow-scrolling: touch;
      display: -webkit-box;
      white-space: nowrap;
      margin: 0 rem(30px);
      padding-bottom: rem(30px);
      .photo_topic_item {
        display: inline-block;
        width: rem(180px);
        margin-left: rem(24px);
        border-radius: rem(8px);
        overflow: hidden;
        // padding-bottom: rem(12px);
        border: rem(1px) solid #cccccc;
        border-radius: rem(8px);
        .photo_topic_photo {
          img {
            width: rem(180px);
            height: rem(180px);
            object-fit: cover;
          }
        }

        .photo_topic_info {
          // border: rem(1px) solid #cccccc;
          // border-radius: 0 0 rem(8px) rem(8px);
          border-top: none;
          padding: rem(12px);
          .photo_topic_name {
            height: rem(28px);
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: rem(24px);
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #262626;
            line-height: rem(28px);
          }
          .photo_topic_label {
            display: flex;
            height: rem(32px);
            flex-wrap: wrap;
            overflow: hidden;
            span {
              height: rem(32px);
              padding: rem(4px);
              margin-left: rem(8px);
              font-size: rem(20px);
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: 400;
              background: #fff2eb;
              border-radius: rem(4px);
              color: #ff8800;
              line-height: rem(24px);
              margin-bottom: rem(10px);
            }
            :nth-child(1) {
              margin-left: 0;
            }
          }
        }
      }

      :nth-child(1) {
        margin-left: 0;
      }
    }
    .photo_topic_list::-webkit-scrollbar {
      display: none;
    }
  }

  .photo_basic_warp {
    background-color: white;
    padding: rem(30px) rem(30px) 0;

    .basic_photo {
      display: flex;
      flex-wrap: wrap;
      .basic_item {
        margin-top: rem(32px);
        display: flex;
        width: 33.333%;

        .basic_child {
          display: flex;
          align-items: center;
          img {
            width: rem(44px);
            height: rem(44px);
          }
          .info {
            margin-left: rem(20px);
            font-size: rem(24px);
            line-height: rem(28px);
            p {
              color: #808080;
              @include ellicpsis;
              max-width: calc(33vw - 50px);
            }
            div {
              margin-top: rem(6px);
              font-weight: bold;
              color: #262626;
              @include ellicpsis;
              max-width: calc(33vw - 50px);
            }
          }
        }
      }
    }
  }

  .photo_warpper {
    .photo_item_warp {
      padding: 0 rem(30px);
      background-color: white;
      .top48 {
        padding-top: rem(48px);
      }
      .info {
        margin-top: rem(20px);
        display: flex;
        line-height: rem(32px);
        font-size: rem(26px);

        align-items: center;
        p {
          color: #666666;
          min-width: rem(160px);
        }
        div {
          color: #262626;
        }
      }
    }
    .more-look {
      margin-top: rem(-8px);
      margin-bottom: rem(20px);
      background-color: white;
    }
  }

  .serve_introduce_title {
    font-size: rem(28px);
    color: #121212;
    line-height: rem(34px);
  }

  .image_text {
    background-color: #fff;
    padding: 0 rem(30px);
    .image_text_title {
      padding-top: rem(32px);
      padding-bottom: rem(32px);
    }
    .pDetail {
      width: 100%;
      text-align: center;
      overflow: hidden;
      margin-bottom: rem(32px);
      max-height: rem(420px);
      .img-detail {
        overflow: hidden;
      }
      img {
        max-width: 100%;
        display: block;
      }
    }
  }
  .noMore {
    padding-bottom: rem(1px);
    .pDetail {
      max-height: none;
    }
    .more-look {
      display: none;
    }
  }
  .isAll {
    .pDetail {
      max-height: none;
    }
    .more-look {
      background-image: url('~@/assets/images/product/btn-sq@3x.png');
      background-size: rem(82px) auto;
    }
  }
}

.bright-content {
  padding: rem(48px) rem(30px) 0;
  background-color: #fff;
}
.bright_title {
  margin-bottom: rem(16px);
}

.bright_title .content_detail {
  word-break: break-all;
}
.content_detail {
  font-size: rem(26px);
  color: #262626;

  word-break: break-all;
  ul {
    li {
      position: relative;
      padding: rem(10px) 0;
      line-height: rem(32px);
      display: flex;
      justify-content: space-between;
      padding-left: rem(20px);
      span {
        padding-left: rem(10px);
        flex: none;
      }
      &:before {
        content: '';
        position: absolute;
        z-index: 2;
        top: 50%;
        left: 0;
        border-radius: 100%;
        background-color: #262626;
        width: rem(8px);
        height: rem(8px);
        transform: translateY(-50%);
      }
    }
  }

  // 移到上层
  //   h3 {
  //     //padding-top: rem(26px);
  //     padding-bottom: rem(14px);
  //     line-height: rem(32px);
  //     font-size: rem(26px);
  //     color: #262626;
  //     font-weight: bold;
  //     span {
  //       font-weight: normal;
  //       font-size: rem(24px);
  //       color: #808080;
  //     }
  //   }
  p {
    line-height: rem(32px);
    font-size: rem(26px);
    color: #808080;
    padding-top: rem(14px);
    word-break: break-all;
  }
}
.combo-detail {
  padding: 0 rem(30px);
  margin-top: rem(10px);
  background-color: #fff;
  padding-top: rem(32px);
  &.isAll {
    padding-bottom: rem(10px);
  }
  .combo_title {
    background-image: url('~@/assets/images/product/icon-tcxq@3x.png');
  }
  > ul {
    margin-bottom: rem(32px);
    li {
      margin-top: rem(32px);
      @include border(all, #f0f0f0, 1px, 0.16rem);
      overflow: hidden;
      h4 {
        height: rem(72px);
        line-height: rem(72px);
        background-color: #fff2eb;
        padding: 0 rem(24px);
        font-size: rem(28px);
        font-weight: 700;
        color: #262626;
      }
    }
  }
}
.block-ui {
  padding: rem(22px) rem(25px);

  .one-line {
    display: flex;
    align-items: flex-start;
    font-size: rem(26px);
    padding: rem(10px) 0;
    &:last-child {
      padding-bottom: 0;
    }
    label {
      flex: none;
      width: rem(152px);
      color: #333;
    }
    div {
      color: #000;
      flex: auto;
      p {
        line-height: rem(32px);
        padding-bottom: rem(12px);
        &:last-child {
          padding-bottom: 0;
        }
      }
      &.one-line-ul.position-ui {
        display: flex;
        flex-wrap: wrap;
        > p {
          > span {
            display: none;
          }
          &:last-child {
            i {
              display: none;
            }
          }
        }
      }
    }
  }
}
.more-look {
  display: block;
  width: 100%;
  height: rem(96px);
  background: url('~@/assets/images/product/btn-ckgd@3x.png') no-repeat;
  background-position: center;
  background-size: rem(134px) auto;
  margin-top: rem(-32px);
}
/deep/ .van-image-preview__swipe {
  img {
    transform: translate3d(0, 0, 0);
  }
}
/deep/.van-image-preview__index {
  top: 0;
  line-height: rem(88px);
  // padding-top: rem(60px);
  // padding-bottom: rem(20px);
  font-size: rem(36px);
  color: #ffffff;
  font-family: PingFangSC, PingFangSC-Medium;
  .gray {
    color: #999999;
  }
}
</style>
